var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.24929C2.5 8.89897 2.5 8.72381 2.51462 8.57628C2.6556 7.15334 3.78127 6.02767 5.20421 5.88669C5.35174 5.87207 5.53636 5.87207 5.90558 5.87207C6.04785 5.87207 6.11899 5.87207 6.17939 5.86841C6.95061 5.8217 7.62595 5.33495 7.91414 4.61807C7.93671 4.56193 7.95781 4.49864 8 4.37207C8.04219 4.2455 8.06329 4.18221 8.08586 4.12607C8.37405 3.40919 9.04939 2.92244 9.82061 2.87573C9.88101 2.87207 9.94772 2.87207 10.0811 2.87207H14.9189C15.0523 2.87207 15.119 2.87207 15.1794 2.87573C15.9506 2.92244 16.626 3.40919 16.9141 4.12607C16.9367 4.18221 16.9578 4.2455 17 4.37207C17.0422 4.49864 17.0633 4.56193 17.0859 4.61807C17.374 5.33495 18.0494 5.8217 18.8206 5.86841C18.881 5.87207 18.9521 5.87207 19.0944 5.87207C19.4636 5.87207 19.6483 5.87207 19.7958 5.88669C21.2187 6.02767 22.3444 7.15334 22.4854 8.57628C22.5 8.72381 22.5 8.89897 22.5 9.24929V17.0721C22.5 18.7522 22.5 19.5923 22.173 20.234C21.8854 20.7985 21.4265 21.2575 20.862 21.5451C20.2202 21.8721 19.3802 21.8721 17.7 21.8721H7.3C5.61984 21.8721 4.77976 21.8721 4.13803 21.5451C3.57354 21.2575 3.1146 20.7985 2.82698 20.234C2.5 19.5923 2.5 18.7522 2.5 17.0721V9.24929Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.3721C14.7091 17.3721 16.5 15.5812 16.5 13.3721C16.5 11.1629 14.7091 9.37207 12.5 9.37207C10.2909 9.37207 8.5 11.1629 8.5 13.3721C8.5 15.5812 10.2909 17.3721 12.5 17.3721Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera01);
export default __webpack_public_path__ + "static/media/camera-01.d456b04680b1148284f452cd3a897a13.svg";
export { ForwardRef as ReactComponent };